import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { CacheResolverService } from './cacheResolverService';
const TIME_TO_LIVE = 5000;
  const cachedURLs: string[] = [
    '/api/identity/accounts/getsplicense',
    '/api/administration/users/permissions',
    '/api/identity/accounts/get-baselicense'
  ]
@Injectable()
export class CacheInterceptor implements HttpInterceptor {

  constructor(private cacheService: CacheResolverService){}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    var _curURL = req.url.substring(req.url.indexOf('/api')).toLocaleLowerCase();
    if(cachedURLs.includes(_curURL) == true){
      return next.handle(req);
    }
    /* if(_curURL.toLocaleLowerCase().includes('/api/administration/users/permissions') == false){
      return next.handle(req);
    } */
      const cachedResponse = this.cacheService.get(req.url);
      return cachedResponse? of(cachedResponse) : this.setRequest(req,next);
  }
  setRequest(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    var _curURL = req.url.substring(req.url.indexOf('/api')).toLocaleLowerCase();
    return next.handle(req).pipe(
      tap((event) =>{
        if(cachedURLs.includes(_curURL) == true){
          if(event instanceof HttpResponse){
            this.cacheService.set(_curURL, event, TIME_TO_LIVE);
          }
        }
      })
    );
  }
}
